import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '治愈番专区', to: '/category/healing' },
  { label: '日常番合集', to: '/category/daily' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 border-b border-background-200/70 backdrop-blur' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-cup-line text-lg"></i>
          </span>
          <span className="font-brand text-2xl leading-none text-foreground-950">
            牛奶动漫库
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-full px-4 py-2 text-sm font-medium transition ${
                pathname === item.to
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/category/healing"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-accent-600"
          >
            <i className="ri-heart-line"></i>
            开始补番
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-950 md:hidden"
        >
          <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`block rounded-xl px-4 py-3 text-base font-medium transition ${
                pathname === item.to
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/category/healing"
            className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-5 py-3 text-base font-medium text-background-50"
          >
            <i className="ri-heart-line"></i>
            开始补番
          </Link>
        </div>
      )}
    </header>
  );
}